<ng-template #oeblock let-oe>
  <ng-container *ngIf="oe.oe_enmIdent_OETyp === 2">
    <p>
      <em><strong>{{enumSvc.getEnumerationText("AnredeTyp", oe.oe_enmIdent_AnredeTyp)}}</strong></em>
      <em><strong>{{oe.oeNPraefix}}</strong></em>
      <em><strong>{{oe.oeEName}} {{oe.oeName}}</strong></em>
      <em class="grid-auto-1">
        <ng-container *ngIf="oe.oe_CrmRolle && oe.oe_CrmRolle !== 0">
          <em class="typo-small">{{enumSvc.getFieldCaption('OE', 'oe_CrmRolle')}}&nbsp;&nbsp;&nbsp;</em>
          <em class="typo-small">{{enumSvc.getEnumerationText('CrmRollePerson', oe.oe_CrmRolle)}}</em>
        </ng-container>
      </em>
    </p>
  </ng-container>
  <ng-container *ngIf="oe.oe_enmIdent_OETyp !== 2">
    <p>
      <em>{{oe.oeNPraefix}}</em>
      <em><strong>{{oe.oeName}}</strong></em>
      <em class="grid-auto-1">
        <ng-container *ngIf="oe.oe_enmIdent_OETyp && oe.oe_enmIdent_OETyp !== 0">
          <em class="typo-small">{{enumSvc.getFieldCaption('OE', 'oe_enmIdent_OETyp')}}&nbsp;&nbsp;&nbsp;</em>
          <em class="typo-small">{{enumSvc.getEnumerationText('OETyp', oe.oe_enmIdent_OETyp)}}</em>
        </ng-container>
        <ng-container *ngIf="oe.oe_CrmRolle && oe.oe_CrmRolle !== 0">
          <em class="typo-small">{{enumSvc.getFieldCaption('OE', 'oe_CrmRolle')}}&nbsp;&nbsp;&nbsp;</em>
          <em class="typo-small">{{enumSvc.getEnumerationText('CrmRolleOrganisation', oe.oe_CrmRolle)}}</em>
        </ng-container>
      </em>
    </p>
  </ng-container>
</ng-template>

  <div class="layout-auto-1-auto">
    <h5 class="">
      Details
    </h5>
    <div class="content">
      <ng-container *ngIf="SummaryData?.OEDetails as OE">
        <div class="layout-auto-1">
          <div>
            <ng-container *ngTemplateOutlet="oeblock; context: {$implicit: OE}"></ng-container>

          </div>
          <div class="content">
            <app-exg-tab-v2 [hidden]="!SummaryData" [header]="tabs">
              <ng-template #pages>
                <div class="content">
                  <div class="typo-container-s-s-q">
                    <ng-container *ngFor="let contType of contacts | keyvalue">
                      <ng-container *ngIf="contType.key !== 'null'">
                      <span class="typo-small">{{enumSvc.getEnumerationText("KontaktTyp",
                                                                            getNumber(contType.key))}}</span>
                        <span>
                      <ng-container *ngFor="let cont of getArray(contType.value)">
                        <div>{{cont.kontVal}}</div>
                      </ng-container>
                      </span>
                        <q></q>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <div class="content">
                  <div class="typo-container-s-s-q">
                    <ng-container *ngFor="let adrType of addresses | keyvalue">
                      <ng-container *ngIf="adrType.key !== 'null'">
                      <span class="typo-small">{{enumSvc.getEnumerationText("AdresseTyp",
                                                                            getNumber(adrType.key))}}</span>
                        <span>
              <ng-container *ngFor="let adr of getArray(adrType.value)">
                 <div>{{adr.adrStr}} {{adr.adrHNum}}, {{adr.adrPlz}} {{adr.adrOrt}}</div>
              </ng-container>
            </span>
                        <q></q>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <div class="content">
                  <div class="typo-container-s-s-q">
                    <ng-container *ngFor="let member of SummaryData.Persons">
                      <ng-container>
                      <span class="typo-small">{{member.oeName + ',' + member.oeEName}}</span>
                        <span>
            </span>
                        <q></q>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <div class="content">
                  <div class="typo-container-s-s-q">
                    <ng-container *ngFor="let member of SummaryData.MemberOf">
                      <ng-container>
                        <span class="typo-small">{{member.oeName + ',' + member.oeEName}}</span>
                        <span>
            </span>
                        <q></q>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <div class="content">
                  <div class="typo-container-s-s-q">
                    <ng-container *ngFor="let member of SummaryData.Members">
                      <ng-container>
                        <span class="typo-small">{{member.oeName + ',' + member.oeEName}}</span>
                        <span>
            </span>
                        <q></q>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <div class="content">
                  <div class="typo-container-s-s-q">
                    <ng-container *ngFor="let member of SummaryData.Groups">
                      <ng-container>
                        <span class="typo-small">{{member.grpKBZ}}</span>
                        <span>
            </span>
                        <q></q>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </app-exg-tab-v2>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="">
    </div>
  </div>
